module.exports = __webpack_public_path__ + "img/img30.a3934ec2.svg";